import React, { useCallback, useRef } from 'react'
import styled from 'styled-components'
import Button from '../../components/Button'
import Modal, { ModalRef } from '../../components/Modal'
import Switch from '../../components/Switch'
import { useDispatch, useSelector } from '../../store/hooks'
import { useTranslation } from '../../store/hooks/dataHooks'
import { useConfiguratorMode } from '../../store/hooks/uiHooks'
import ExpertModePreview from './../modals/ExpertModePreview'

export const ViewSwitcher = styled(function ViewSwitcher({ className }) {
  const dispatch = useDispatch()
  const expertModeOverlay = useRef<ModalRef>(null)

  const toggleExpertMode = useCallback(() => {
    expertModeOverlay.current?.show()
  }, [])

  const showFinal = useCallback(() => {
    dispatch({
      type: 'Ui/ShowFinal'
    })
  }, [dispatch])

  const t = useTranslation()

  const { expert, toggleMode } = useConfiguratorMode()

  const exportModeEnabled = useSelector((state) => !!state.data.urls.expertMode)

  return (
    <>
      <div className={className}>
        <label onClick={exportModeEnabled ? undefined : toggleExpertMode}>
          Expert Mode
          <Switch checked={expert} onChange={exportModeEnabled ? toggleMode : undefined} />
        </label>
        <Button onClick={showFinal} cta>
          {t('ui.request-offer')}
        </Button>
      </div>
      <Modal ref={expertModeOverlay}>
        <ExpertModePreview />
      </Modal>
    </>
  )
})`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  justify-content: space-between;
  padding: 20px;
  margin-top: 20px;
  background: rgba(255, 255, 255, 0.15);
  pointer-events: all;

  > label {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
  }

  .button {
    margin-bottom: 0;
    margin-left: 60px;
  }

  ${Switch} {
    margin-left: 15px;
  }
`
